<template>
    <v-dialog v-model="dialog" max-width="800px">
        <v-btn fab dark small slot="activator" class="primary">
            <v-icon dark>insert_drive_file</v-icon>
        </v-btn>
        <v-card>
            <v-card-title>
                <h2>Edit File Types</h2>
            </v-card-title>
            <v-card-text>
                <v-container grid-list-md>
                    <v-layout wrap>
                    <v-flex xs6>
                        <v-text-field v-model="newFileTypeName" label="New File Type name"></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                        <v-btn color="primary" flat @click="createFileType">Create File Type</v-btn>  
                    </v-flex>
                    </v-layout>
                    <v-tabs
                        dark
                        color="cyan"
                        show-arrows
                        @change="tabChanged"
                    >
                        <v-tabs-slider color="yellow"></v-tabs-slider>

                        <v-tab
                        v-for="fileType in fileTypes"
                        :key="fileType.name"
                        :href="'#tab-' + fileType.name"
                        >
                        {{ fileType.name }}
                        </v-tab>

                        <v-tabs-items>
                        <v-tab-item
                            v-for="(fileType, fileTypeIndex) in fileTypes"
                            :key="fileType.name"
                            :value="'tab-' + fileType.name"
                        >
                            <v-card flat>
                                <v-card-text>
                                    <v-btn color="red" flat @click="deleteFileType(fileType.name)">Delete File Type</v-btn>
                                    <v-layout wrap>
                                        <v-flex xs6>
                                            <v-text-field v-model="newField" label="New Field name"></v-text-field>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-btn color="primary" flat @click="createField(fileTypeIndex)">Create field</v-btn>  
                                        </v-flex>
                                    </v-layout>
                                    <v-flex v-for="(field, fieldIndex) in fileType.fields">
                                    {{ field }}
                                    <v-btn color="red" flat @click="deleteField(fileTypeIndex, fieldIndex)">Delete field</v-btn>
                                    </v-flex>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                        </v-tabs-items>
                    </v-tabs>  
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat @click="dialog = false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
        data() {
            return {
                dialog: false,
                newFileTypeName: '',
                newField: '',
                fileTypesLocal: this.fileTypes ? this.fileTypes.slice(0) : []
            }
        },
        methods: {
            ...mapActions([
                'updateFileTypes',
            ]),
            tabChanged() {
                this.newField = ''
            },
            _updateFileTypes() {
                this.updateFileTypes({
                    id: this.clientId,
                    fileTypes: this.fileTypesLocal
                })
            },
            createFileType() {
                this.fileTypesLocal.push({
                    name: this.newFileTypeName
                })
                this._updateFileTypes()
                this.newFileTypeName = ''
            },
            deleteFileType(name) {
                this.fileTypesLocal = this.fileTypesLocal.filter(function (obj) {
                    return obj.name != name
                })
                this._updateFileTypes()
            },
            deleteField(fileTypeIndex, fieldIndex) {
                this.$delete(this.fileTypesLocal[fileTypeIndex].fields, fieldIndex)
                this._updateFileTypes()
                this.newField = ''
            },
            createField(fileTypeIndex) {
                if (!('fields' in this.fileTypesLocal[fileTypeIndex])) {
                    this.fileTypesLocal[fileTypeIndex].fields = []
                }
                this.fileTypesLocal[fileTypeIndex].fields.push(this.newField)
                this._updateFileTypes()
                this.newField = ''
            }
        },
        props: ['clientId', 'clientName', 'fileTypes']
}
</script>